import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import RoomServiceIcon from '@mui/icons-material/RoomService';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import {
  PATH_RESOLVABLE_SERVICES,
  PATH_RESOLVABLE_SERVICES_NEW,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { ResolvableServiceList } from '../../components/ResolvableServiceList';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const ResolvableServicesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ResolvableServices);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Services')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_SERVICES,
            label: 'services',
            key: 'resolvableServices',
          },
        ]}
      />
      <PageTitle title="Liste des Services" />
      <ResolvableServiceList />
      <SpeedDial
        actions={[
          {
            id: 'createResolvableService',
            icon: <RoomServiceIcon />,
            name: 'Créer Service',
            to: PATH_RESOLVABLE_SERVICES_NEW,
          },
        ]}
        title="Actions possibles sur les Services"
      />
    </>
  );
};
